'use strict';

var MITS = require('../mits');
var Util = require('../UI/Util');
var WidgetUtils = require('./WidgetUtils');
WidgetUtils.requireStylesheet('MITS.Widgets.OrderableItemList');

/**
 * Displays a collection of items can be ordered and removed. Ordering
 * is done with drag/drop and remove is done by double clicking.
 * The widget must start as an empty container
 * and have items dynamically added.  This widget can be used inside
 * of a form to post the ordered items.  Alternatively, it can return
 * the ordered item IDs to include in an AJAX request.
 */
var OrderableItemList = function (container, options) {
    this.initialize(container, options);
};

OrderableItemList._instanceCount = 1;
OrderableItemList.prototype = {

    //--- Constants ---
    _divIdPrefix: 'orderableItemId_',
    _topAnchorDivIdPrefix: 'topAnchorId_',

    //--- Internal State Variables ----
    // Counts the total items that have been added. NOT the same as current
    // item count because it doesn't decrement when removing.
    _sequenceCounter: 0,
    _currentItemCount: 0,
    // Maps from item IDs to the unique sequence number
    _itemToSequenceNumberMap: null,
    // Maps from the unique sequence numbers to the item ID
    _sequenceNumberToItemMap: null,
    _sequenceNumberToDescriptionMap: null, // and to its description
    _container: null,

    //--- Configurable Defaults ----
    _moveListener: function () {
    },
    _removeListener: function () {
    },
    _removeIconCssClass: 'fa fa-times fa-2x',
    _lockedIconUrl: 'fa fa-lock',
    _oddItemCss: 'oddDraggable',
    _evenItemCss: 'evenDraggable',
    _oddUndraggableItemCss: 'oddUndraggable',
    _evenUndraggableItemCss: 'evenUndraggable',
    _descriptionCss: 'undraggableDescription',
    _draggingCss: 'movingDraggable',
    _contentCss: 'draggableContent',
    _scrollContainer: null,
    _formFieldName: null,
    _makeHtmlLiteral: false,
    //Currently always true because I can't get the padding right in both cases.
    _itemsAreRemovable: true,
    _doubleclickRemoves: true,


    /**
     * @param container - The ID of a (presumably) empty DOM element for which the draggable elements will be placed.
     * @param options - contains the following optional settings:
     *        removeListener: A function called when the widget has
     *            removed an item due to the remove icon being clicked.
     *            It is passed the item ID.
     *      removeIconCssClass: A relative url to the image to use as the remove-button.
     *      removeIconHoverUrl: A different image to display as the remove-button when hovering over it
     *        oddItemCss: A CSS class name added to every other item in the list
     *        evenItemCss: A CSS class name added to every other item in the list
     *        draggingCss: A CSS class name added to an item while it is being dragged
     *        isContainerScrollable: Indicates if the container has a scroll bar that
     *            should be auto-scrolled when the user drags an item to the top or
     *            bottom.  If not set to true, the default is to scroll the window if needed.
     *        formFieldName: When using this widget inside of a form, a hidden form
     *            field will be created for each item.  The caller provides the
     *            name of the form field by setting the formFieldName, and the
     *            value of the form fields will be the IDs of the items.
     */
    /* eslint-disable complexity */
    initialize: function (container, options) {

        if (typeof container !== 'string'){
            console.error('For the ValuesList widget, expecting the input parameter \'container\' to be of type string, but was type \'' + (typeof container) + '\'.');
        }
        //Give this instance a unique prefix it can use for it's items so they don't clash
        //with IDs for items from other OrderableItemList instances on the same page.
        this._divIdPrefix = this._divIdPrefix + OrderableItemList._instanceCount + '_';
        this._topAnchorDivIdPrefix = this._topAnchorDivIdPrefix + OrderableItemList._instanceCount + '_';
        OrderableItemList._instanceCount++;

        //Note: These can't be initialized prior to this in the prototype because
        //we want each instance to have its own map instead of globally shared maps.
        this._itemToSequenceNumberMap = {};
        this._sequenceNumberToItemMap = {};
        this._sequenceNumberToDescriptionMap = {};

        jQuery('#' + container).empty();
        this._container = document.getElementById(container);

        if (options) {
            if (options.moveListener) {
                this._moveListener = options.moveListener;
            }

            if (options.removeListener) {
                this._removeListener = options.removeListener;
            }

            if (options.doubleclickRemoves != null) {
                this._doubleclickRemoves = options.doubleclickRemoves;
            }

            if (options.oddItemCss) {
                this._oddItemCss = options.oddItemCss;
            }

            if (options.evenItemCss) {
                this._evenItemCss = options.evenItemCss;
            }

            if (options.draggingCss) {
                this._draggingCss = options.draggingCss;
            }

            if (options.formFieldName) {
                this._formFieldName = options.formFieldName;
            }

            if (options.removeIconCssClass) {
                this._removeIconCssClass = options.removeIconCssClass;
            }

            if (options.makeHtmlLiteral) {
                this._makeHtmlLiteral = options.makeHtmlLiteral;
            }

            if (options.isContainerScrollable) {
                this._scrollContainer = this._container;
            }
            else {
                this._scrollContainer = window;
            }
        }

        var lastPlaceholderIndex = -1;

        var _this = this;
        jQuery(this._container).sortable({
            containerSelector: '#' + this._scrollContainer.id,
            // This is necessary to distinguish between lists opened on the same page. This includes the same one opened,
            // closed, and reopened because jQuery-sortable reuses objects if you let is, confusing everything.
            group: 'OrderableItemListContainer' + OrderableItemList._instanceCount,
            axis: 'y',
            itemSelector: '.oddDraggable,.evenDraggable',
            placeholder: '<div id="placeholder" class="placeholder"/>',
            //The scroll-specific parameters are used by the OrderableItemList to handle scrolling, as scrolling isn't explicitly supported
            //in the underlying jquery-sortable component.
            scroll: true,
            scrollSensitivity: 20,
            scrollSpeed: 8,
            adjustment: {},

            // Makes item you are moving stay under the cursor at the place that you clicked it to start dragging
            //rather than having the item you are moving off to the side of the cursor
            onDragStart: function ($item, container, _super) {
                if (this.scroll) {
                    if (container.superSearchValidTarget === undefined) {
                        // Squirreling away the super impl so it can be called by the overriding method below
                        // See: https://github.com/johnny/jquery-sortable/blob/0.9.13/source/js/jquery-sortable.js line 313
                        container.superSearchValidTarget = container.searchValidTarget;
                    }

                    var initialScrollPosition = {
                        lastPointerScrollTop: null,
                        scrollTop: _this._scrollContainer.scrollTop
                    };

                    // The Container.searchValidTarget method is responsible for finding where the placeholder is placed.
                    // Unfortunately it isn't aware of the scroll container's scroll position. Overriding it here so as t
                    // to pass in pointer positions that reflect the scroll position
                    container.searchValidTarget = function (pointer) {
                        var adjustedPointer = Object.assign({}, pointer, {top: pointer.top - (initialScrollPosition.scrollTop - _this._scrollContainer.scrollTop)});
                        var adjustedLastPointer = initialScrollPosition.lastPointer;
                        initialScrollPosition.lastPointer = adjustedPointer;

                        return container.superSearchValidTarget(adjustedPointer, adjustedLastPointer);
                    };
                }
                //Alter the placeholder associated with the container so that it uses a copy of the element being dragged.
                container.group.placeholder = jQuery($item).clone().prop('id', 'placeholder').addClass('placeholder');

                //Alter the dragged element so that it shows the 'selected' style under all circumstances.  This is done to make sure
                //that the dragged element keeps it's selected state even if the user mouses outside of the scroll container, but continues
                //to drag.
                $item.addClass('movingDraggable textSelectionDisabled');

                lastPlaceholderIndex = -1;
                var offset = $item.offset(), pointer = container.rootGroup.pointer;

                this.adjustment = {
                    left: pointer.left - offset.left,
                    top: pointer.top - offset.top
                };

                _super($item, container);
            },

            //Makes item you are moving stay under the cursor at the place that you clicked it to start dragging.
            //By only modifying the vertical positioning of the dragged element, we are able to prevent unnecessary horizontal
            //movement of the dragged element that doesn't serve a functional purpose.
            onDrag: function ($item, position) {
                //Reposition the ghost placeholder image that tracks mouse movement.
                $item.css({
                    top: jQuery(_this._scrollContainer).scrollTop() + position.top - this.adjustment.top
                });

                //Do scrolling
                if (this.scroll) {
                    //The jQuery-sortable implementation that we're using doesn't support scrolling.  As such, it's necessary to add
                    //in support for it here.  For the time being, this only supports vertical scrolling.
                    if (position.top < this.scrollSensitivity) {
                        _this._scrollContainer.scrollTop = _this._scrollContainer.scrollTop - this.scrollSpeed;
                    } else if (position.top >= _this._scrollContainer.offsetHeight - this.scrollSensitivity){
                        _this._scrollContainer.scrollTop = _this._scrollContainer.scrollTop + this.scrollSpeed;
                    }
                }
            },

            onDrop: function ($item, container, _super) {
                //Alter the dragged element so that it will no longer have the 'selected' style.
                $item.removeClass('movingDraggable');

                _super($item, container);
                _this._resetOddEvenCss();
            },

            //As the afterMove callback tracks every time the mouse moves, rather than only when the placeholder's position moves,
            //We track the index of the placeholder to detect when it has changed, and only then elements that we need to redraw.
            afterMove: function (placeholder, container, item) {
                var placeholderIndex = jQuery('#placeholder').index();
                if (placeholderIndex !== lastPlaceholderIndex) {
                    if (lastPlaceholderIndex !== -1) {
                        //Iterate over the subset of elements that have swapped positions due to the most recent move of the placeholder
                        //so that each element's even/odd striping can be properly set to reflect the change.
                        //NOTE: The nth-child call is one-indexed, while the placeholder index is zero-indexed.
                        if (placeholderIndex < lastPlaceholderIndex) {
                            //If the placeholder is being moved upward, toggle the even/odd CSS of all elements
                            //from after the new location of the placeholder, up to and including the previous location of the placeholder.
                            for (var i = placeholderIndex + 1; i <= lastPlaceholderIndex; i++) {
                                _this._toggleOddEvenCss(jQuery(container.options.containerSelector + ' > :nth-child(' + (i + 1) + ')'));
                            }
                        } else {
                            //If the placeholder is being moved downward, toggle the even/odd CSS of all elements
                            //from the previous location of the placeholder to just before the new location of the placeholder.
                            for (var i = lastPlaceholderIndex; i <= placeholderIndex - 1; i++) {
                                _this._toggleOddEvenCss(jQuery(container.options.containerSelector + ' > :nth-child(' + (i + 1) + ')'));
                            }
                        }
                    }
                    lastPlaceholderIndex = placeholderIndex;
                }
            }
        });
        //HACK monkey patching the ContainerGroup.getPointer with one that works correctly on Android. The broken one
        //returns {left: undefined, right: undefined } confusing user code
        //See: https://github.com/johnny/jquery-sortable/blob/0.9.13/source/js/jquery-sortable.js line 403
        var _s = jQuery.data(this._container).sortable;
        _s.group.getPointer = function(e) {
            var o;
            if (!(e.originalEvent) || !(e.originalEvent.touches) || !(e.originalEvent.touches[0])) {
                o = {};
            } else {
                o = e.originalEvent.touches[0];
            }
            return {
                left: e.pageX || o.pageX,
                top: e.pageY || o.pageY
            };
        };
    },
    /* eslint-enable complexity */

    addItem: function (id, description) {
        if (this.containsItem(id)) {
            return;
        }

        this._itemToSequenceNumberMap[id] = this._sequenceCounter;
        this._sequenceNumberToItemMap[this._sequenceCounter] = id;
        this._sequenceNumberToDescriptionMap[this._sequenceCounter] = description;

        var div = document.createElement('div');
        div.id = this._divIdPrefix + this._sequenceCounter;

        if (this._currentItemCount % 2 === 0) {
            div.className = this._oddItemCss;
        } else {
            div.className = this._evenItemCss;
        }

        var draggableContent = this._generateDraggableContent(id, description);
        div.appendChild(draggableContent);

        if (this._formFieldName) {
            var formField = document.createElement('input');
            formField.type = 'hidden';
            formField.name = this._formFieldName;
            formField.value = id;
            div.appendChild(formField);
        }
        if (this._itemsAreRemovable && this._doubleclickRemoves) {
            this._addDoubleClickRemoveListener(div, id);
        }
        this._container.appendChild(div);
        this._sequenceCounter++;
        this._currentItemCount++;
    },

    addItemToUndraggableTopAnchoredSet: function (name, description) {
        var id = this._topAnchorDivIdPrefix + name;
        if (!document.getElementById(id)) {
            var div = document.createElement('div');

            div.id = id;

            var content = this._generateTopAnchorUndraggableContent(name, description);

            div.appendChild(content);

            // add right before top-most draggable item
            if (!this._container.hasChildNodes()) {
                this._container.appendChild(div);
            } else {
                var child = this._container.firstChild;
                while (child && child.tagName === 'DIV' && this._isATopAnchorId(child.id)) {
                    child = child.nextSibling;
                }

                if (child) {
                    this._container.insertBefore(div, child);
                } else {
                    this._container.appendChild(div);
                }
            }
        }

        this._resetOddEvenCss();
    },

    /**
     * Gets an array of the item IDs, in the order the items
     * appear.
     */
    getOrderedIds: function () {
        var itemIdArray = new Array();

        var divList = jQuery('#' + this._container.id).children();
        for (var i = 0; i < divList.length; i++) {
            var div = divList[i];
            var sequenceNumber = div.id.substring(this._divIdPrefix.length);
            var itemId = this._sequenceNumberToItemMap[sequenceNumber];
            itemIdArray.push(itemId);
        }

        return itemIdArray;
    },

    getOrderedDescriptions: function () {
        var itemDescriptionArray = new Array();

        var divList = jQuery('#' + this._container.id).children();
        for (var i = 0; i < divList.length; i++) {
            var div = divList[i];
            var sequenceNumber = div.id.substring(this._divIdPrefix.length);
            var itemDescription = this._sequenceNumberToDescriptionMap[sequenceNumber];
            itemDescriptionArray.push(itemDescription);
        }

        return itemDescriptionArray;
    },

    updateItemDescription: function (id, newDescription) {
        var sequenceNumber = this._itemToSequenceNumberMap[id];
        if (typeof sequenceNumber != 'number') {
            //item isn't in our list
            return;
        }
        var div = document.getElementById(this._divIdPrefix + sequenceNumber);
        var dragHandleDiv = div.firstChild;
        dragHandleDiv.removeChild(dragHandleDiv.firstChild);
        dragHandleDiv.appendChild(this._generateDraggableContent(id, newDescription));
    },

    removeItem: function (id) {
        var sequenceNumber = this._itemToSequenceNumberMap[id];
        if (typeof sequenceNumber != 'number') {
            //item isn't in our list
            return;
        }
        var div = document.getElementById(this._divIdPrefix + sequenceNumber);

        //Set the odd/even css for the items below the one
        //we're removing
        var currentItem = div.nextSibling;
        while (currentItem) {
            this._toggleOddEvenCss(currentItem);
            currentItem = currentItem.nextSibling;
        }

        this._container.removeChild(div);
        this._itemToSequenceNumberMap[id] = null;
        this._currentItemCount--;
    },

    removeAllItemsFromUndraggableTopAnchoredSet: function () {
        var divList = jQuery('#' + this._container.id).children();
        for (var i = 0; i < divList.length; i++) {
            var div = divList[i];
            if (this._isATopAnchorId(div.id)) {
                this._container.removeChild(div);
            }
        }
        this._resetOddEvenCss();
    },

    _isATopAnchorId: function (id) {
        var prefix = this._topAnchorDivIdPrefix;
        var preLen = prefix.length;
        return id && id.length >= preLen && id.substring(0, preLen) === prefix;
    },

    removeAllItems: function () {
        while (this._container.hasChildNodes()) {
            this._container.removeChild(this._container.firstChild);
        }

        this._itemToSequenceNumberMap = {};
        this._sequenceNumberToItemMap = {};
        this._sequenceNumberToDescriptionMap = {};
        this._currentItemCount = 0;
    },

    /** Indicates if an item with the specified ID is in the table. */
    containsItem: function (id) {
        return typeof this._itemToSequenceNumberMap[id] == 'number';
    },

    _generateDraggableContent: function (id, description) {
        if (this._itemsAreRemovable) {
            //create a table to get the image to center vertically when text wraps
            var table = document.createElement('table');
            var tbody = document.createElement('tbody');
            var row = document.createElement('tr');
            var dragHandleCell = document.createElement('td');
            var dragHandle = document.createElement('i');
            dragHandle.className = 'fa fa-ellipsis-v';
            dragHandleCell.appendChild(dragHandle);
            var cell = document.createElement('td');
            cell.className = 'removeIconCell';
            var image = document.createElement('i');
            image.className = this._removeIconCssClass;
            image.style.cursor = 'pointer';
            this._addSingleClickRemoveListener(image, id);

            var cell2 = document.createElement('td');
            cell2.style.width = '100%';
            cell2.appendChild(this._createItemTextDiv(description));

            table.appendChild(tbody);
            tbody.appendChild(row);
            row.appendChild(dragHandleCell);
            row.appendChild(cell);
            cell.appendChild(image);
            row.appendChild(cell2);

            return table;
        } else {
            return this._createItemTextDiv(description);
        }
    },


    _generateTopAnchorUndraggableContent: function (name, description) {
        var table = document.createElement('table');
        var tbody = document.createElement('tbody');
        var row = document.createElement('tr');
        var cell = document.createElement('td');
        cell.className = 'lockedIconCell';
        var image = document.createElement('i');
        image.className = this._lockedIconUrl;
        var cell2 = document.createElement('td');
        cell2.style.width = '100%';
        var content = this._createItemTextDiv(name);
        content.className = ''; // too much padding
        if (description && description.length > 0) {
            var descContent = this._createItemTextDiv(description);
            descContent.className = this._descriptionCss;
            content.appendChild(descContent);
        }
        cell2.appendChild(content);
        table.appendChild(tbody);
        tbody.appendChild(row);
        row.appendChild(cell);
        cell.appendChild(image);
        row.appendChild(cell2);
        return table;
    },

    _createItemTextDiv: function (text) {
        var textDiv = document.createElement('div');
        textDiv.className = 'draggableText';
        Util.disableTextSelection(textDiv);
        if (this._makeHtmlLiteral) {
            textDiv.appendChild(document.createTextNode(text));
        } else {
            textDiv.innerHTML = text;
        }

        return textDiv;
    },

    _addDoubleClickRemoveListener: function (element, itemId) {
        jQuery(element).dblclick(function () {
                this.removeItem(itemId);
                this._removeListener(itemId);
            }.bind(this)
        );
    },

    _addSingleClickRemoveListener: function (element, itemId) {
        var $element = jQuery(element);
        $element.bind('click touchend', function () {
            this.removeItem(itemId);
            this._removeListener(itemId);
        }.bind(this));
        $element.bind('mousedown touchstart', function (e) {
            e.stopPropagation();
        });
    },

    _toggleOddEvenCss: function (element) {
        if (jQuery(element).hasClass(this._oddItemCss)) {
            jQuery(element).removeClass(this._oddItemCss);
            jQuery(element).addClass(this._evenItemCss);
        } else {
            jQuery(element).addClass(this._oddItemCss);
            jQuery(element).removeClass(this._evenItemCss);
        }
    },

    _resetOddEvenCss: function () {
        var divList = jQuery('#' + this._container.id).children();
        for (var i = 0; i < divList.length; i++) {
            var isUndraggable = this._isATopAnchorId(divList[i].id);
            if (i % 2 === 0) {
                jQuery(divList[i]).removeClass(this._evenItemCss);
                jQuery(divList[i]).removeClass(this._evenUndraggableItemCss);
                jQuery(divList[i]).addClass(isUndraggable ? this._oddUndraggableItemCss : this._oddItemCss);
            } else {
                jQuery(divList[i]).removeClass(this._oddItemCss);
                jQuery(divList[i]).removeClass(this._oddUndraggableItemCss);
                jQuery(divList[i]).addClass(isUndraggable ? this._evenUndraggableItemCss : this._evenItemCss);
            }
        }
    }
};

module.exports = OrderableItemList;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/OrderableItemList.js
// module id = 37
// module chunks = 0